import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './header.css';
import logo from '../../img/zz.png'; // Adjust path if needed

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Track scroll to switch header style
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => setIsMobileMenuOpen(v => !v);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // Helper to style active links in React Router v6
  const navClass = ({ isActive }) =>
    `nav-link ${isActive ? 'active' : ''}`;

  return (
    <header className={`ef-header ${isScrolled ? 'scrolled' : ''}`} role="banner">
      {/* thin gradient line on top */}
      <div className="ef-header-topline" aria-hidden="true" />

      <div className="ef-header-wrap">
        {/* Logo */}
        <div className="ef-logo-wrap">
          <NavLink to="/" onClick={closeMobileMenu} className="ef-logo-link" aria-label="Ecodesign & Protect — Home">
            <img src={logo} alt="Ecodesign & Protect Ltd" className="ef-logo" />
          </NavLink>
        </div>

        {/* Desktop Nav */}
        <nav className="ef-nav" aria-label="Primary">
          <ul className="ef-nav-list">
            <li><NavLink to="/" end className={navClass} onClick={closeMobileMenu}>Home</NavLink></li>
            <li><NavLink to="/about-us" className={navClass} onClick={closeMobileMenu}>About Us</NavLink></li>
            <li><NavLink to="/contact-us" className={navClass} onClick={closeMobileMenu}>Contact Us</NavLink></li>
            <li><NavLink to="/our-services" className={navClass} onClick={closeMobileMenu}>Our Services</NavLink></li>
            <li><NavLink to="/our-partners" className={navClass} onClick={closeMobileMenu}>Clients & Partners</NavLink></li>
            <li>
              <a
                href="https://197.243.23.16:2096/"
                className="ef-webmail-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Webmail
              </a>
            </li>
          </ul>
        </nav>

        {/* Mobile toggle */}
        <button
          type="button"
          className={`ef-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-menu"
          onClick={toggleMobileMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile slide-in panel */}
      <div
        id="mobile-menu"
        className={`ef-mobile-panel ${isMobileMenuOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
      >
        <ul className="ef-mobile-list">
          <li><NavLink to="/" end className={navClass} onClick={closeMobileMenu}>Home</NavLink></li>
          <li><NavLink to="/about-us" className={navClass} onClick={closeMobileMenu}>About Us</NavLink></li>
          <li><NavLink to="/contact-us" className={navClass} onClick={closeMobileMenu}>Contact Us</NavLink></li>
          <li><NavLink to="/our-services" className={navClass} onClick={closeMobileMenu}>Our Services</NavLink></li>
          <li><NavLink to="/our-partners" className={navClass} onClick={closeMobileMenu}>Clients &amp; Partners</NavLink></li>
          <li>
            <a
              href="https://197.243.23.16:2096/"
              className="ef-webmail-btn"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
            >
              Webmail
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
